import { ShortMessageActions } from './actions'
import { ShortMessageGetters } from './getters'
import { ShortMessageMutations } from './mutations'
import { ShortMessageState } from './state'

export const SHORT_MESSAGE_NAMESPACE = 'shortMessage'

export const ShortMessage = {
  namespaced: true,
  state: ShortMessageState,
  actions: ShortMessageActions,
  mutations: ShortMessageMutations,
  getters: ShortMessageGetters,
}
